import { AuthGuard } from './../_guards/auth.guard';
import { TemplateComponent } from 'src/app/_template/template.component';
import { Route } from '@angular/router';
import { modalConfigDefaults } from 'ngx-bootstrap/modal/modal-options.class';
import { ProfileComponent } from './_components/profile/profile.component';

export const TemplateRoutes: Route[] = [
  {
    path: "labviewer",
    component: TemplateComponent,
    canActivate: [AuthGuard],
    canActivateChild: [AuthGuard],
    children: [
      {
        path: "home",
        loadChildren: () =>
          import("./_components/home/home.module").then((h) => h.HomeModule),
        // component: HomeComponent
      },
      {
        path: "dashboard",
        loadChildren: () =>
          import("./_components/dashboard/dashboard.module").then(
            (h) => h.DashboardModule
          ),
        //   loadChildren: () => import('./_components/query/query.module')
        //               .then(q => q.QueryModule)
      },
      /* {
                path: 'search-menu',
               // loadChildren: () => import('./_components/search-page/search-page.module').then(s => s.SearchPageModule)
               component: SearchPageComponent
            }, */
      {
        path: "profile",
        component: ProfileComponent,
      },

      {
        path: "queries",
        loadChildren: () =>
          import("./_components/query/query.module").then(
            (mod) => mod.QueryModule
          ),
      },
      {
        path: '',
         loadChildren: () => import('./_components/home/home.module')
         .then(h => h.HomeModule)
      // component: HomeComponent
    }
,
      // coloque sus rutas aqui //
      /* {   path: 'products', component: ProductsComponent },
            {   path: 'products/:id', component: ProductsComponent },
            {   path: 'products-list', component: ProductsListComponent }*/
    ],
  },
  {
    path: "labviewer/sub/queries",
    loadChildren: () =>
      import("./_components/query/query.module").then((mod) => mod.QueryModule),
  },
];
